<!--
 * @Author: wangjiaxiang
 * @Date: 2022-03-16 11:00:02
 * @LastEditTime: 2022-09-26 14:09:02
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/views/contents/babyWikipedia/audioDetail.vue
 *
-->
<template>
  <div class="audio-box">
    <!-- 返回按钮 -->
    <!-- 小程序环境隐藏返回导航 -->
    <Back v-if="!checkFromMiniprogram" @goBack="goBack">
      <div slot="header">
        <div class="back" @click.stop="goBack">
          <van-icon name="arrow-left" size="20"/>
        </div>
      </div>
    </Back>
    <!-- 音频信息 -->
    <audioInfo
        ref="audio"
        :audioInfo="audioInfo"
        :isButtonDisable="audioCollection.length"
        @audioSwitch="audioSwitch"
        @isUserLogin="isUserLogin"
        @prevAudio="prevAudio"
        @taskFinish="taskFinish"
    />
    <!-- 小程序环境隐藏点赞/收藏/分享/评论输入框 -->
    <comment-field
        v-if="!checkFromMiniprogram"
        ref="focus"
        :articalId="audioInfo.id"
        :carrierId="carrierId"
        :isGoLogin="isGoLogin"
        :title="audioInfo.name"
        @isLogin="globalGoLogin"
    >
      <!-- 点赞模块 -->
      <template slot="audio">
        <span class="commentShare" @click.stop="onLike(audioInfo)">
          <div>
            <img
                :src="
                !audioInfo.orLike
                  ? require('@/assets/images/icon/like_.png')
                  : require('@/assets/images/icon/like3.png')
              "
            />
            <span class="num">{{ fomatterNum(audioInfo.likeNum) }}</span>
          </div>
        </span>
        <!-- 收藏 -->
        <span class="commentShare share3" @click.stop="onCllect(audioInfo)">
          <div>
            <img
                :src="
                !audioInfo.orFavorites
                  ? require('@/assets/images/icon/praise_.png')
                  : require('@/assets/images/baby/iconcollect.png')
              "
                alt
                class="share2 collect-shareshare"
            />
            <span class="num">{{ fomatterNum(audioInfo.collectNum) }}</span>
          </div>
        </span>
        <!-- 分享 -->
        <span class="commentShare share2" @click.stop="shareLink(audioInfo)">
          <div>
            <img alt class="share1" src="@/assets/images/icon/share_.png"/>
          </div>
        </span>
      </template>
    </comment-field>
    <!-- 小程序环境隐藏评论列表/分享弹窗/登录引导 -->
    <template v-if="!checkFromMiniprogram">
      <all-comment
          ref="allComment"
          :articalId="audioInfo.id"
          :carrierId="carrierId"
          :isGoLogin="isGoLogin"
          :title="audioInfo.name"
          @focusOn="getFocusOn"
          @toReplyCom="toReplyCom"
          @type="getType"
      ></all-comment>
      <audioShare ref="share"></audioShare>
      <login-tip
          :show="checkLogin"
          @cancleWay="cancleWay"
          @confirmWay="confirmWay"
      ></login-tip>
    </template>
  </div>
</template>

<script>
// 组件
import Back from "@/components/common/goBack";
import audioInfo from "./components/audioInfo.vue";
import allComment from "@/components/comment/allComment.vue";
import commentField from "@/components/comment/commentField.vue";
import audioShare from "@/components/comment/share.vue";
import loginTip from "@/views/contents/calendar/component/logintip"; //注册提示组件
// 接口
import API_KAQI from "@/utils/axiosApi/cageChildApi.js"; //凯琪育儿详情
import API_ from "@/utils/axiosApi/audioApi.js"; //api育儿音频事件
import {addIntegral} from '@/utils/newMemberApiGlobal'
// 方法
import {Debounce, fomatterNum, getCookie, getUrlParamsByName, globalGoLogin, isFromMiniprogram, isUserLogin} from "@/assets/js/common.js"; //工具类
export default {
  name: "audiodetail",
  components: {
    Back,
    audioInfo,
    commentField,
    allComment,
    audioShare,
    loginTip,
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userInfo")), //用户信息
      audioInfo: {}, //音频信息对象
      carrierId: "",
      type: "", // 模块不一样请求接口不一样
      checkLogin: false, //跳转登录弹框
      audioCollection: [], //当前音频类下所有音频
      pageParams: {
        page: Number(this.$route.query.page) || 1, //首页进来使用路由上面带过来的页码
        size: 25,
        finished: false,
      },
      routeInfo: {}, //路由信息
      homeAudioPage: 0, //首页音频的总页码
      isClick: true, //切换音频开关
    };
  },
  watch: {
    audioInfo(newValue, oldValue) {
      // 判断第一次进来请求接口
      if (newValue.id && !oldValue.id) {
        // 判断是home页进来的音频走另一个获取列表接口
        if (this.routeInfo.from == "home") {
          this.getSongHome();
        }
      }
    },
  },
  computed: {
    isGoLogin() {
      return isUserLogin();
    },
    // 判断是否来自小程序环境
    checkFromMiniprogram() {
      return isFromMiniprogram(this.$route);
    },
  },
  created() {
    this.initPage();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // sessionStorage.setItem("pre", getUrlParamsByName("fromPath") || from.path);
      vm.$store.commit("changeIncludes", [
        "home",
        "wikipediaIndex",
        "wikipediaList",
        "babyFeeding"
      ]);
    });
  },
  beforeDestroy() {
    this.$refs.audio.$refs.audio.pause();
  },
  mounted() {
  },
  methods: {
    fomatterNum,
    getCookie,
    globalGoLogin,
    // 接口统一管理
    common(item) {
      return {
        // 点赞
        onLike: {
          doctorHome: API_KAQI.addLike,
          cagechild: API_KAQI.addLike,
          audio: API_.getLike,
          collect: API_.getLike,
          search: API_.getLike,
          newAudio: API_KAQI.addLike,
        }[this.type],
        // 取消点赞
        cancelLike: {
          doctorHome: API_KAQI.cancleLike,
          cagechild: API_KAQI.cancleLike,
          audio: API_.cancelLike,
          collect: API_.cancelLike,
          search: API_.cancelLike,
          newAudio: API_KAQI.cancleLike,
        }[this.type],
        // 收藏
        onCllect: {
          cagechild: API_KAQI.addCollect,
          doctorHome: API_KAQI.addCollect,
          audio: API_.getCllect,
          collect: API_.getCllect,
          search: API_.getCllect,
          newAudio: API_KAQI.addCollect,
        }[this.type],
        // 取消收藏
        cancelCllect: {
          cagechild: API_KAQI.cancelCollect,
          doctorHome: API_KAQI.cancelCollect,
          audio: API_.cancelCllect,
          collect: API_.cancelCllect,
          search: API_.cancelCllect,
          newAudio: API_KAQI.cancelCollect,
        }[this.type],
        // 详情接口
        eventAPI: {
          cagechild: API_KAQI.getAudioDetail,
          doctorHome: API_KAQI.getAudioDetail,
          audio: API_.getAudioDetail,
          collect: API_.getAudioDetail,
          search: API_.getAudioDetail,
          newAudio: API_KAQI.getAudioDetail,
        }[this.type],
      }[item];
    },
    // 初始化详情页面
    initPage() {
      const routeInfo = this.$route.query;
      this.routeInfo = routeInfo;
      // 0 凯琪 1 育儿 其他音频模块有待添加
      switch (routeInfo.type) {
        case "0":
        case "2":
          this.type = "cagechild";
          break;
        case "1":
        case "3":
          this.type = "audio";
          break;
      }
      this.getAudioDetail(routeInfo); //获取详情
      this.getAudioData(routeInfo); // 获取总数据
      this.addPlay(routeInfo.id); // 增加播放量

    },
    addPlay(id){
      API_.addPlay({}, { id }, (res) => {});
     },
    // 首页进来的音频切换
    getSongHome(status, id) {
      this.$http.post(
          "/audio/getAudioList",
          {},
          {
            data: {},
            page: this.pageParams.page,
            size: 10,
          },
          (res) => {
            if (res.code === "200") {
              const {content, totalElements} = res.data;
              this.homeAudioPage = Math.ceil(totalElements / 10);
              this.audioCollection = content;
              // 下一首的页码逻辑
              if (status == "next") {
                var currentAudio = {};
                // 找到当前播放完毕的音频id
                let audioIndex = this.audioCollection.findIndex((item) => {
                  return item.id == id;
                });

                if (audioIndex >= this.audioCollection.length - 1) {
                  // 循环到第一首播放
                  currentAudio = this.audioCollection[0];
                } else {
                  currentAudio = this.audioCollection[++audioIndex];
                }

                // if (this.audioCollection.length >= totalElements) {
                //   // 数据加载完毕
                //   this.pageParams.finished = true;
                // } else {
                //   this.pageParams.page += 1;
                // }
              } else if (status == "pre") {
                //上一首的页码逻辑
                var currentAudio = {};
                // 找到当前播放完毕的音频id
                let audioIndex = this.audioCollection.findIndex((item) => {
                  return item.id == id;
                });
                if (audioIndex != -1 && id != this.audioCollection[0].id) {
                  currentAudio = this.audioCollection[--audioIndex];
                } else {
                  currentAudio = this.audioCollection[
                  this.audioCollection.length - 1
                      ];
                }
              }
              this.isClick = true; // 打开开关
              switch (currentAudio.type) {
                case 0:
                  this.type = "cagechild";
                  break;
                case 1:
                  this.type = "audio";
                  break;
              }
              this.getAudioDetail({
                id: currentAudio.id,
                type: currentAudio.type,
              });

              console.log(this.audioCollection);
            }
          }
      );
    },
    // 星育儿-凯琪姐说育儿/星妈讲故事 articleType: 0 凯琪 1 星妈讲故事
    getAudioData() {
      if (Number(this.routeInfo.navActive)) {
        this.$http.post(
            "/breedWiki/fairyTales",
            {},
            {
              data: {
                periodId: String(this.routeInfo.period_id),
                tagId: String(this.routeInfo.tag_id),
                fnTagId: this.routeInfo.fnTagId,
              },
              page: this.pageParams.page,
              size: this.pageParams.size,
            },
            (res) => {
              if (res.code == 200) {
                let {data, total} = res.data;
                data = data.filter((item) => {
                  return item.columnId == 3;
                });
                this.audioCollection = [...this.audioCollection, ...data];
                if (this.audioCollection.length >= total) {
                  this.pageParams.finished = true;
                } else {
                  this.pageParams.page += 1;
                }
              }
            }
            , null, 'lucky'
        );
      } else {
        this.$http.post(
            "/breedWiki/getAudio",
            {},
            {
              data: {
                periodId: String(this.routeInfo.period_id),
                tagId: String(this.routeInfo.tag_id),
                articleType: String(this.routeInfo.type),
                isHot: String(this.routeInfo.tag_id == -1 ? 1 : 0), //0非推荐数据  1推荐数据
              },
              page: this.pageParams.page,
              size: this.pageParams.size,
            },
            (res) => {
              if (res.code == 200) {
                const {data, total} = res.data;
                this.audioCollection = [...this.audioCollection, ...data];
                if (this.audioCollection.length >= total) {
                  // 数据加载完毕
                  this.pageParams.finished = true;
                } else {
                  this.pageParams.page += 1;
                }
                console.log(this.audioCollection);
              }
            }
            , null, 'lucky'
        );
      }
    },
    /**
     * @description: 获取详情
     * @param {object} routeInfo 路由参数
     * @return {*}
     */

    getAudioDetail(routeInfo) {
      console.log(routeInfo);
      switch (routeInfo.type) {
        case "0":
        case "2":
          this.carrierId = "6";
          break;
        case "1":
        case "3":
          this.carrierId = "5";
          break;
      }
      this.common("eventAPI")(
          {},
          {id: routeInfo.id, crmId: this.userInfo ? this.userInfo.crm_id : ""},
          (res) => {
            if (res.code == "200") {
              res.data.audioUrl = res.data.audioAddress || res.data.contentUrl;
              res.data.audioTitle = res.data.audioTitle || res.data.name;
              this.audioInfo = res.data;
              // 音频分享
              let param = window.location.href.split("?")[1];
              let goPath =
                  this.$http.hostName +
                  "/babyWikipedia/audiodetail?" +
                  param +
                  "&share=1";
              var shareDataParams = {
                shareLink: goPath,
                shareDesc:
                    this.carrierId == "5"
                        ? "每天一个故事，用爱养育宝宝，用心陪伴孩子"
                        : "每天一点育儿小知识，陪你从新妈变星妈！",
                shareTitle:
                    this.carrierId == "6"
                        ? res.data.name
                        : res.data.title,
                imgUrl: res.data.coverUrl, //必须是绝对路径
                shareid: res.data.id,
                shareFlag: true,
                shareType: "audio",
              };
              console.log(shareDataParams);
              this.wxJsSet.wxShare("fx", shareDataParams, this);
              // 埋点
              sensors.track("ContentView", {
                content_id: res.data.id,
                content_title: res.data.title,
                author: "",
              });
            }
          }
      );
    },
    // 播放结束自动切换音频
    audioSwitch(id) {
      // 找到当前播放完毕的音频id
      let audioIndex = this.audioCollection.findIndex((item) => {
        return item.id == id;
      });
      var currentAudio = {};
      // 判断是home页进来的音频走另一个获取列表接口
      if (this.routeInfo.from == "home") {
        if (audioIndex == this.audioCollection.length - 1) {
          if (this.isClick) {
            this.isClick = false;
            // 判断不为最后一页 页码加1
            if (this.pageParams.page < this.homeAudioPage) {
              this.pageParams.page++;
            } else {
              this.pageParams.page = 1;
            }
            this.getSongHome("next", id);
          }
        } else {
          currentAudio = this.audioCollection[++audioIndex];
          switch (currentAudio.type) {
            case 2:
              this.type = "cagechild";
              break;
            case 3:
              this.type = "audio";
              break;
          }
          this.getAudioDetail({id: currentAudio.id, type: currentAudio.type});
        }
      } else {
        // 星育儿进入
        if (
            audioIndex >= this.audioCollection.length - 2 &&
            !this.pageParams.finished
        ) {
          this.getAudioData(); // 获取总数据
        }
        if (audioIndex >= this.audioCollection.length - 1) {
          // 循环到第一首播放
          currentAudio = this.audioCollection[0];
        } else {
          currentAudio = this.audioCollection[++audioIndex];
        }

        switch (currentAudio.type) {
          case 0:
          case 2:
            this.type = "cagechild";
            break;
          case 1:
          case 3:
            this.type = "audio";
            break;
        }
        this.getAudioDetail({id: currentAudio.id, type: currentAudio.type});
      }
    },
    // 切换上一首
    prevAudio(id) {
      var currentAudio = {};
      // 找到当前播放完毕的音频id
      let audioIndex = this.audioCollection.findIndex((item) => {
        return item.id == id;
      });
      if (this.$route.query.from == "home") {
        if (audioIndex <= 0) {
          if (this.isClick) {
            this.isClick = false;
            // 判断为第一页第一首 直接取最后一页数据
            if (this.pageParams.page == 1) {
              this.pageParams.page = this.homeAudioPage;
            } else {
              //如果不为第一页 让当前页减1 请求上页数据
              this.pageParams.page = --this.pageParams.page;
            }
            this.getSongHome("pre", id);
          }
        } else {
          currentAudio = this.audioCollection[--audioIndex];
          switch (currentAudio.type) {
            case "0":
            case "2":
              this.type = "cagechild";
              break;
            case "1":
            case "3":
              this.type = "audio";
              break;
          }
          this.getAudioDetail({id: currentAudio.id, type: currentAudio.type});
        }
      } else {
        if (audioIndex <= 0) {
          // 循环到第一首播放
          currentAudio = this.audioCollection[this.audioCollection.length - 1];
        } else {
          currentAudio = this.audioCollection[--audioIndex];
        }
        switch (currentAudio.type) {
          case "0":
          case "2":
            this.type = "cagechild";
            break;
          case "1":
          case "3":
            this.type = "audio";
            break;
        }
        this.getAudioDetail({id: currentAudio.id, type: currentAudio.type});
      }
    },
    columnTest() {
      let senorCage = ["doctorHome", "cagechild", "newAudio"];
      let senorye = ["collect", "search", "audio"];
      if (senorCage.includes(this.type)) {
        return "凯淇育儿";
      }
      if (senorye.includes(this.type)) {
        return "育儿音频";
      }
    },
    likeResponse(type, item, fn) {
      let o = {
        crmId: this.userInfo.crm_id,
        id: item.id,
      };

      if (type == "cagechild" || type == "doctorHome" || type == "newAudio") {
        this.common("onLike")(o, (res) => {
          fn(res);
        });
      } else {
        this.common("onLike")({}, o, (res) => {
          fn(res);
        });
      }
    },
    canclelikeResponse(type, item, fn) {
      let o = {
        crmId: this.userInfo.crm_id,
        id: item.id,
      };
      if (type == "cagechild" || type == "doctorHome" || type == "newAudio") {
        this.common("cancelLike")(o, (res) => {
          fn(res);
        });
      } else {
        this.common("cancelLike")({}, o, (res) => {
          fn(res);
        });
      }
    },
    // 点赞
    onLike: Debounce(function (item) {
      if (item.orLike) {
        this.cancelLike(item);
      } else {
        if (this.isGoLogin) {
          globalGoLogin()
        } else {
          this.likeResponse(this.type, item, (res) => {
            if (res.code == 200) {
              this.audioInfo.orLike = true;
              this.audioInfo.likeNum++;
              this.$toast({
                duration: 2000,
                message: "点赞成功",
                context: this,
              });
            } else {
              this.$toast("网络异常");
            }
          });
          sensors.track("Support", {
            content_id: item.id,
            content_title: item.name,
            Column: this.columnTest(),
            Poster_Date: "",
          });
        }
      }
    }, 500),
    //取消点赞
    cancelLike: Debounce(function (item) {
      if (this.isGoLogin) {
        globalGoLogin()
      } else {
        this.canclelikeResponse(this.type, item, (res) => {
          if (res.code == 200) {
            this.audioInfo.orLike = false;

            this.audioInfo.likeNum > 0 && this.audioInfo.likeNum--;
          } else {
            this.$toast("网络异常");
          }
          sensors.track("Unsupport", {
            content_id: item.id,
            content_title: item.name,
            Column: this.columnTest(),
            Poster_Date: "",
          });
        });
      }
    }, 500),
    onCllectResponse(type, item, fn) {
      console.log(type);
      let o = {
        crmId: this.userInfo.crm_id,
        id: item.id,
      };
      if (type == "cagechild" || type == "doctorHome" || type == "newAudio") {
        this.common("onCllect")(o, (res) => {
          fn(res);
        });
      } else {
        this.common("onCllect")({}, o, (res) => {
          fn(res);
        });
      }
    },
    //收藏
    onCllect: Debounce(function (item) {
      if (item.orFavorites) {
        this.cancelCllect(item);
      } else {
        if (this.isGoLogin) {
          globalGoLogin()
        } else {
          this.onCllectResponse(this.type, item, (res) => {
            if (res.code == 200) {
              this.audioInfo.collectNum++;
              this.audioInfo.orFavorites = true;
              this.$toast({
                duration: 2000,
                message: "收藏成功",
                context: this,
              });
            } else {
              this.$toast("网络异常");
            }
          });

          sensors.track("Save", {
            content_id: item.id,
            content_title: item.name,
            Column: this.columnTest(),
            Poster_Date: "",
            // A_B_flow: this.ABtest,
          });
        }
      }
    }, 500),
    // 取消收藏
    cancelCllect: Debounce(function (item) {
      if (this.isGoLogin) {
        globalGoLogin()
      } else {
        this.cancelCllectResponse(this.type, item, (res) => {
          if (res.code == 200) {
            this.audioInfo.collectNum--;
            this.audioInfo.orFavorites = false;
          } else {
            this.$toast("网络异常");
          }
        });

        sensors.track("CancelSave", {
          content_id: item.id,
          content_title: item.name,
          Column: this.columnTest(),
          Poster_Date: "",
          //   A_B_flow: this.ABtest,
        });
      }
    }, 500),
    cancelCllectResponse(type, item, fn) {
      let o = {
        crmId: this.userInfo.crm_id,
        id: item.id,
      };
      if (
          this.type == "cagechild" ||
          this.type == "doctorHome" ||
          type == "newAudio"
      ) {
        this.common("cancelCllect")(o, (res) => {
          fn(res);
        });
      } else {
        this.common("cancelCllect")({}, o, (res) => {
          fn(res);
        });
      }
    },
    //分享
    shareLink: Debounce(function (item) {
      this.$refs.share.showShareVideo();
      API_.shareLink({}, {id: item.id}, (res) => {
        if (res.code == 200) {
          setTimeout(() => {
            if (this.audioInfo.orShare) {
              this.audioInfo.shareNum++;
            }
            this.audioInfo.orShare = true;
          }, 500);
        } else {
          this.$toast("网络异常");
        }
      });
      sensors.track("Share", {
        content_id: item.id,
        content_title: item.name,
        Column: this.columnTest(),
        Poster_Date: "",
        // A_B_flow: this.ABtest,
      });
    }, 100),
    toReplyCom(item) {
      this.$store.commit("saveAuidoTime",{
        page: this.$store.state.page,
        id: item.carrierSpecificId,
        audioTime: this.$refs.audio.$refs.audio.currentTime,
      });
    },
    // 返回上一页
    goBack() {
      if (window.history.length > 1 && this.getCookie("fromPath")) {
          this.$router.go(-1);
      } else {
          this.$router.push("/babyWikipedia");
      }
    },
    getFocusOn(bool) {
      this.$refs.focus.isFocus = bool;
    },
    getType(type) {
      this.$refs.focus.type = type;
    },
    // 确认
    confirmWay() {
      this.checkLogin = false;
      this.globalGoLogin();
      // this.loginRegistSensors("确定");
    },
    // 取消
    cancleWay() {
      this.$refs.audio.$refs.audio.pause();
      this.$refs.audio.$refs.audio.currentTime = 9;
      this.checkLogin = false;
      // this.loginRegistSensors("取消");
    },
    loginRegistSensors(msg) {
      sensors.track("Login_registration_pop_up", {
        operation: msg,
        page_name: "京城名医",
      });
    },
    isUserLogin() {
      if (isUserLogin()) {
        this.$refs.audio.$refs.audio.pause();
        this.$refs.audio.playStatus = false;
        this.checkLogin = true;
      }
    },
    // 完成任务
    taskFinish() {
      addIntegral({
        taskGroupCode: "YDWZ00002",
        crmId: this.userInfo?.crm_id
      }, this, '播放完成')
    },
  },
};
</script>

<style lang="less" scoped>
.audio-box {
  overflow-x: hidden;
  background: #fff;
  min-height: 100vh;
  height: auto;
  // 返回按钮
  .back {
    position: relative;
    top: 10px;
    left: 6px;
  }
}
</style>
